import Transaction from '@/models/Transaction'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    transactionDetails: null
  },

  mutations: {
    setTransactionList(state, transactions) {
      each(transactions, transaction => {
        const exist = find(state.list, { id: transaction.id })
        if (!exist) {
          state.list.push(new Transaction(transaction))
        }
      })
    },

    setTransactionListMeta(state, meta) {
      state.listMeta = meta
    },

    clearTransactionList(state) {
      state.list = []
      state.listMeta = {}
    },

    setTransactionDetails(state, transaction) {
      if (transaction instanceof Transaction) {
        state.transactionDetails = transaction
      } else {
        state.transactionDetails = new Transaction(transaction)
      }
    },

    clearTransactionDetails(state) {
      state.transactionDetails = null
    }
  },

  actions: {
    async getTransactions({ commit }, params) {
      const query = Transaction.page(params.page || 1).include('gallery')

      /* Check if for only a specific user */
      if (params.user) {
        query.custom(`users/${params.user}/transactions`)
      } else {
        query.custom('transactions')
      }

      if (params.search) {
        query.where('search', params.search)
      }

      if (params.status) {
        query.where('status', params.status)
      }

      const res = await query.params({ limit: 20 }).get()

      commit('setTransactionList', res.data)
      commit('setTransactionListMeta', res.meta)
    },

    async getTransactionDetails({ commit, rootState }, params) {
      const { data } = await Api.get(
        params.user
          ? `users/${params.user}/transactions/${params.id}`
          : `transactions/${params.id}`
      )
      commit('setTransactionDetails', data.data)
    }
  }
}
